import "./styles/styles.css";
import RouteHandler from "./Routes/Routes";
import ReactGA from "react-ga4";
import { useEffect } from "react";

// import { getGPUTier } from "detect-gpu";

// useEffect(() => {
//   const detectGPU = async () => {
//     const gpuTier = await getGPUTier();

//     if (gpuTier.fps < 45) {
//       window.location.replace(
// // address to load
//       );
//     }
//   };

//   detectGPU();
// }, []);

export default function App() {
  useEffect(() => {
    ReactGA.initialize("G-C2CSBV7BQ9");
  }, []);

  return <RouteHandler />;
}
